import { DeprecatedModal } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { useCallback } from "react";
import type { DialogLayoutDispatchProps } from "../DialogLayout/DialogLayout";
import ErrorContextProvider from "../ErrorContext/ErrorContext";
interface CustomDialogStateProps {
    open: boolean;
}
export interface RenderProps extends DialogLayoutDispatchProps, CustomDialogStateProps {
}
interface CustomDialogRenderProps extends RenderProps {
    render: (props: RenderProps) => React.ReactNode;
}
export interface CustomDialogProps extends CustomDialogRenderProps, DialogLayoutDispatchProps, CustomDialogStateProps {
    className?: string;
    accessibleName?: string;
}
// eslint-disable-next-line jsdoc/require-param
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
export const CustomDialog: React.FC<CustomDialogProps> = ({ open, render, close, accessibleName, ...rest }) => {
    const handleClose = useCallback(() => {
        if (close) {
            close();
        }
    }, [close]);
    const renderProps = { open, close: handleClose };
    return (<ErrorContextProvider>
            <DeprecatedModal open={open} className={rest.className}>
                <div role="dialog" aria-label={accessibleName}>
                    {open && render(renderProps)}
                </div>
            </DeprecatedModal>
        </ErrorContextProvider>);
};
CustomDialog.displayName = "CustomDialog"
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
export default React.memo(CustomDialog);
